import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Card from "components/card";
import { apiGet } from "lib/apiClient";

/** The compact hub row on the partner dashboard — "where do my markets sit, and is
 *  anything of mine waiting on me" — with the full picture one click away on the Hubs
 *  page. Stats are this tenant's own slice, exactly as /portal/hubs already scopes them. */
export default function HubsWidget() {
  const [hubs, setHubs] = useState(null);

  useEffect(() => {
    apiGet("/portal/hubs")
      .then((result) => setHubs(result.hubs || []))
      .catch(() => setHubs([]));
  }, []);

  if (hubs && hubs.length === 0) return null;

  return (
    <Card extra="p-5 xl:col-span-2">
      <div className="flex items-center justify-between">
        <p className="text-lg font-semibold text-navy-700 dark:text-white">Hubs</p>
        <Link to="/portal/hubs" className="text-sm font-semibold text-brand-500">
          View all →
        </Link>
      </div>
      {!hubs ? (
        <p className="mt-2 text-sm text-gray-500">…</p>
      ) : (
        <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2">
          {hubs.map((hub) => {
            const openMarkets = hub.stats.openInstanceCount + hub.stats.legacyOpenMarketCount;
            const needsAttention = hub.stats.pendingApprovalCount + hub.stats.awaitingResolutionCount;
            return (
              <div key={hub.id} className="flex items-center gap-3 rounded-xl border border-gray-200 p-3 dark:border-white/10">
                <span
                  className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-lg"
                  style={{ background: hub.color ? `${hub.color}22` : undefined }}
                >
                  {hub.icon || hub.name.slice(0, 2).toUpperCase()}
                </span>
                <div className="min-w-0">
                  <p className="truncate text-sm font-semibold text-navy-700 dark:text-white">{hub.name}</p>
                  <p className="text-xs text-gray-500">
                    {openMarkets} open market{openMarkets === 1 ? "" : "s"}
                    {needsAttention > 0 ? ` · ${needsAttention} need${needsAttention === 1 ? "s" : ""} you` : ""}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
}
